var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Modal',[_c('div',{staticClass:"box"},[_c('Loading')],1)]):_vm._e(),_vm._v(" "),(_vm.show)?_c('div',[_c('button',{staticClass:"button mr-4",on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{class:this.localIcon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.localTitle))])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }